(function () {
  function getProductList(doc) {
    return (
      doc.querySelector('product-list.product-list') ||
      doc.querySelector('#main product-list') ||
      doc.querySelector('product-list')
    );
  }

  function getLoadMoreButton(doc) {
    return doc.querySelector('[data-load-more][data-next-url]');
  }

  async function fetchHTML(url) {
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch next page');
    return await res.text();
  }

  // Reveal only the wrapper (do NOT touch descendants, avoids double-image/overexposure)
  function revealNode(node) {
    node.removeAttribute('reveal-on-scroll');
    node.classList.remove('reveal-on-scroll', 'is-hidden');
    node.removeAttribute('hidden');

    // Clear any inline hidden styles, then force visible
    node.style.opacity = '';
    node.style.transform = '';
    node.style.visibility = '';

    node.style.opacity = '1';
    node.style.transform = 'none';
    node.style.visibility = 'visible';
  }

  // Nudge Prestige to initialise newly-added nodes (fixes "works on the next load")
  function reInitPrestige(list) {
    requestAnimationFrame(() => {
      // Trigger common observers (lazyload/reveal/layout)
      window.dispatchEvent(new Event('scroll'));
      window.dispatchEvent(new Event('resize'));

      // Ping Shopify/Theme lifecycle hooks (safe no-ops if unused)
      try {
        const section = list.closest('section');
        document.dispatchEvent(
          new CustomEvent('shopify:section:load', {
            detail: { sectionId: section ? section.id : null },
          })
        );
      } catch (e) {}

      document.dispatchEvent(new Event('theme:load'));
    });
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-load-more][data-next-url]');
    if (!btn) return;

    const list = getProductList(document);
    if (!list) return;

    const nextUrl = btn.dataset.nextUrl;
    if (!nextUrl) return;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'LOADING…';

    try {
      const html = await fetchHTML(nextUrl);
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newList = getProductList(doc);
      if (!newList) throw new Error('No product list found on next page');

      // Append new product-card nodes + reveal wrapper only
      const nodes = Array.from(newList.children);
      nodes.forEach((node) => {
        list.appendChild(node);
        revealNode(node);
      });

      // Re-init theme behaviours for first-load reliability
      reInitPrestige(list);

      // Update button to next page URL (or remove if no more pages)
      const newBtn = getLoadMoreButton(doc);
      if (newBtn && newBtn.dataset.nextUrl) {
        btn.dataset.nextUrl = newBtn.dataset.nextUrl;
        btn.disabled = false;
        btn.textContent = originalText;
      } else {
        btn.remove();
      }
    } catch (err) {
      console.error('[Load More error]', err);
      btn.disabled = false;
      btn.textContent = originalText;
    }
  });
})();
